import styled from 'styled-components';
import List from '@material-ui/core/List';

const AppDock = styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: ${props => props.theme.spacing(9)}px;
    height: 100%;
    overflow: auto;
    padding-right: ${props => props.theme.spacing()}px;
    padding-left: ${props => props.theme.spacing()}px;
    background-color: ${props => props.theme.palette.background.dock};
    color: ${props => props.theme.palette.getContrastText(props.theme.palette.background.dock)};
  }
`;

AppDock.propTypes = { ...List.propTypes };

export default AppDock;
